import { request } from "configs/api";
import {
  LoginResponseDto,
  SubmitLoginDto,
  SubmitResetPasswordDto
} from "interfaces/auth";

class AuthService {
  async login(data: SubmitLoginDto): Promise<LoginResponseDto> {
    return request({
      data,
      url: "/auth/user/login",
      method: "POST",
    });
  }

  async register(data: SubmitLoginDto): Promise<undefined> {
    return request({
      data,
      url: "/public/user/sign-up",
      method: "POST",
    });
  }

  async resetPassword(data: SubmitResetPasswordDto): Promise<undefined> {
    return request({
      data,
      url: "/public/user/reset-password",
      method: "POST",
    });
  }
}

export const authService: AuthService = new AuthService();
